"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPinInput = _interopRequireDefault(require("react-pin-input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = {
  border: 'none',
  borderBottom: '3px solid #d8d8d8',
  borderRadius: '0',
  fontFamily: 'Open Sans',
  fontSize: '48px',
  margin: '0',
  marginRight: '2rem',
  paddingBottom: '1.4rem',
  textAlign: 'center',
  width: '5rem'
};
var defaultInputStyle = {
  borderBottom: '3px solid #3b3b3b'
};

var PINInput = function PINInput(_ref) {
  var _ref$inputStyle = _ref.inputStyle,
      inputStyle = _ref$inputStyle === void 0 ? defaultStyle : _ref$inputStyle,
      _ref$inputFocusStyle = _ref.inputFocusStyle,
      inputFocusStyle = _ref$inputFocusStyle === void 0 ? defaultInputStyle : _ref$inputFocusStyle,
      _ref$length = _ref.length,
      length = _ref$length === void 0 ? 4 : _ref$length,
      onPINChange = _ref.onPINChange,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'numeric' : _ref$type;
  return /*#__PURE__*/_react.default.createElement(_reactPinInput.default, {
    focus: true,
    inputStyle: inputStyle,
    inputFocusStyle: inputFocusStyle,
    length: length,
    type: type,
    onChange: onPINChange
  });
};

var _default = PINInput;
exports.default = _default;